

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Event } from '../interfaces/event.interface';
import { namespace } from 'vuex-class';
import moment from 'moment';
import { EventModalParams } from '@/modules/events/interfaces/event-modal-params.interface';

const eventStore = namespace('EventStore');

@Component({
  name: 'EventCard',
})
export default class EventCard extends Vue {
  @Prop({ required: true }) event!: Event;

  @eventStore.Action
  updateEventDetailModalVisibility!: (params: EventModalParams) => void;

  get happeningIn() {
    return moment(this.event.startDate).fromNow();
  }
}
